import { Component, OnInit } from '@angular/core';

import { getObjectiveTripsSelectors } from 'src/app/modules/objective/store/objective.selectors';
import { IObjectivesFormState } from 'src/app/modules/objective/store/objective.state';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { formatDate } from 'src/app/utils/format-date';
import { formatCurrency } from 'src/app/utils/format-currency';

@Component({
  selector: 'app-pdf-trips',
  templateUrl: './pdf-trips.component.html',
  styleUrls: ['./pdf-trips.component.scss'],
})
export class PdfTripsComponent implements OnInit {
  dataStoreTrips$: Observable<any>;
  dataStoreTrips: IObjectivesFormState;
  intendDate: any;
  minInvestimentFormated: string;
  maxInvestimentFormated: string;

  constructor(private store: Store) {}

  getState() {
    this.dataStoreTrips$ = this.store.select(getObjectiveTripsSelectors);
    this.dataStoreTrips$.subscribe((value) => {
      this.dataStoreTrips = {
        ...(this.dataStoreTrips = value),
      };
    });

    this.intendDate = this.dataStoreTrips.date;

    if (this.intendDate) {
      this.intendDate = formatDate(this.intendDate);
    } else {
      this.intendDate = 'data não especificada!';
    }

    this.minInvestimentFormated = formatCurrency(
      this.dataStoreTrips.minimumInvestment
    );
    this.maxInvestimentFormated = formatCurrency(
      this.dataStoreTrips.maximumInvestment
    );
  }

  ngOnInit(): void {
    this.getState();
  }

}
